import { UseNavigateResult } from '@tanstack/react-router'
import { Link } from 'ui/components/Link'
import { TableActions, TableColumn } from 'ui/components/Table'
import { DocumentPeriodStatus } from '~bank-documents/components/DocumentPeriodStatus'
import { DocumentDetailsPeriodItem } from '~bank-documents/types/documentDetails'

import { AlertsDueTooltip } from './components/AlertsDueTooltip'

export const columns = ({
  documentId,
  onDeletePeriod,
  navigate
}: {
  documentId: number
  onDeletePeriod: (periodId: number) => void
  navigate: UseNavigateResult<string>
}): TableColumn<DocumentDetailsPeriodItem>[] => [
  {
    title: 'Period',
    key: 'period',
    render: ({ period, id }) => (
      <Link
        to="/documents/$documentId/periods/$periodId"
        params={{ documentId: documentId.toString(), periodId: id.toString() }}
        data-qa="document period label"
      >
        {period}
      </Link>
    )
  },
  {
    title: 'Expiration Date',
    key: 'expirationDate',
    render: ({ expirationDate }) => expirationDate
  },
  {
    title: 'Status',
    key: 'status',
    render: ({ status }) => <DocumentPeriodStatus name={status} />
  },
  {
    align: 'center',
    title: 'Alerts',
    key: 'alerts',
    render: ({ id, alerts }) => <AlertsDueTooltip id={id} label={alerts} />
  },
  {
    title: 'Actions',
    key: 'id',
    width: '50px',
    render: (period) => (
      <TableActions
        items={[
          {
            type: 'edit',
            onClick: () =>
              navigate({
                to: '/documents/$documentId/edit-period/$periodId',
                params: { documentId: documentId.toString(), periodId: period.id.toString() },
                resetScroll: false
              })
          },
          {
            type: 'delete',
            onClick: () => onDeletePeriod(period.id)
          }
        ]}
      />
    )
  }
]
